import { useEffect } from 'react';
import { useSiteState } from '../../state/state';
import { useParams } from 'react-router';
import { Token } from '../../model/Model';


export const FetchSiteState = () => {
    const { token } = useParams<Token>();
    const { loaded, fetch } = useSiteState();

    useEffect(() => {
        if (token && fetch && !loaded) {
            fetch(token);
        }
    }, [token, loaded, fetch]);

    return null;
};
